query GetGeometryType(
    $id: ID!
    $revisionID: ID!
) {
    geometryType(
        id: $id
        resolution: ["public", "latest"]
    ) {
        id

        deprecated

        name(language: "en") {
            text
        }

        revision(id: $revisionID) {
            createdAt
            id
            raw
            tags
        }
    }
}
